const props = {
  height: { type: Number, default: 0, required: true },
};

export default props;
